module.exports = __webpack_public_path__ + "img/2.b0c1c06.jpg";